import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useCallback, useEffect, useMemo, useState } from "react";
import { IProductDetailProdps } from "../..";
import Thumbnail from "./Thumnail";
import { isImage } from "@Services/Helper";
import dynamic from "next/dynamic";
const ReactImageZoom = dynamic<any>(() => import("react-image-zoom"), {
  ssr: false,
});

const AddShare = dynamic(
  () => import("@Components/Pages/Common/Modal/AddShare"),
  { ssr: false }
);

export default function ProductDetailsLeftTop({
  product,
}: IProductDetailProdps) {
  const theme = useTheme();
  const [imageToShow, setImageToShow] = useState<string>(product.image.url);
  const [imgWidth, setImgWidth] = useState(400);
  const mdToLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const lgPlus = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    setImageToShow(product.image.url);
  }, [product]);

  const handleImageToShowChange = useCallback((url: string) => {
    setImageToShow(url);
  }, []);

  const addNewValue = lgPlus ? 35 : 20;
  const newImgSize = imgWidth + addNewValue;

  useEffect(() => {
    if (lgPlus) {
      setImgWidth(420);
    } else {
      setImgWidth(380);
    }
  }, [mdToLg, lgPlus]);

  const memorizedMedia = useMemo(() => [product.image, ...product.media], [
    product.image,
    product.media,
  ]);
  return (
    <>
      <Grid container sx={{ position: "sticky", top: "200px", zIndex: 1 }}>
        <Grid container>
          <Grid item sm={10.5}>
            {isImage(imageToShow) ? (
              <ReactImageZoom
                width={imgWidth}
                height={400}
                zoomWidth={300}
                img={imageToShow}
                zoomStyle={`
         z-index:2
        `}
                // zoomPosition="bottom"
                // scale={0.8}
                offset={{ vertical: 0, horizontal: 0 }}
              />
            ) : (
              <Box
                component="video"
                src={imageToShow}
                width={imgWidth}
                controls
                muted
                loop
                autoPlay
                sx={{ maxHeight: 380 }}
              />
            )}
            {/* Cart buttons moved to right column below variant selection */}
          </Grid>
          <Box
            style={{
              position: "absolute",
              top: "5px",
              // right: "10%",
              left: `${newImgSize}px`,
            }}
          >
            <AddShare product={product} />
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Thumbnail
            media={memorizedMedia}
            handleImageToShowChange={handleImageToShowChange}
          />
        </Grid>
      </Grid>
    </>
  );
}
